<!--
 * @Descripttion: 协定服务-添加任务量
 * @Date: 2024-08-06 13:58:47
-->
<template>
  <div class="add-task-num">
    <xrk-table
      ref="xrkTableRef"
      :getListAjax="getListAjax"
      :searchConfig="searchConfig"
      :tableConfig="tableConfig"
    ></xrk-table>
  </div>
</template>

<script lang="tsx" setup>
import { ref } from 'vue';
import {
  XrkTable,
  XrkTableProps,
  useTableColumn,
  XrkTableRef,
  useInputColumn,
  BaseInput
} from 'xrk-components';
import { addTaskNumList } from '../data-source/apis';
const xrkTableRef = ref<XrkTableRef>();

const props = withDefaults(
  defineProps<{
    projectId: number;
  }>(),
  {
    projectId: null
  }
);
// 搜索项
const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchBtn: {
    show: true,
    text: '搜索'
  },
  resetBtn: {
    show: true,
    text: '重置'
  },
  searchColumns: [
    useInputColumn({
      label: '姓名',
      prop: 'name',
      type: 'input',
      config: {
        placeholder: '请输入姓名'
      }
    }),
    useInputColumn({
      label: '手机号',
      prop: 'phone',
      type: 'input',
      config: {
        type: 'tel',
        placeholder: '请输入手机号'
      }
    })
  ]
});

// 列表
const tableConfig = ref<XrkTableProps['tableConfig']>({
  tableColumns: [
    useTableColumn({
      type: '_selection',
      prop: 'userId',
      align: 'center',
      fixed: 'left',
      width: 120
    }),
    useTableColumn({
      type: 'index',
      label: '序号'
    }),
    useTableColumn({
      label: '姓名',
      prop: 'name'
    }),
    useTableColumn({
      label: '手机号',
      prop: 'phone'
    }),
    useTableColumn({
      label: '新增任务量',
      prop: 'taskNum',
      render: ({ row }) => {
        return (
          <div>
            <BaseInput
              v-model={row.taskNum}
              type="number"
              placeholder="请输入"
              style={{ width: '100px' }}
            ></BaseInput>
          </div>
        );
      }
    })
  ]
});

const getListAjax = async params => {
  const data = await addTaskNumList({
    ...params,
    projectId: props.projectId
  });
  return data;
};
defineExpose({
  getSelectData: () => {
    return xrkTableRef.value.getSelectionRows().map(item => {
      return {
        projectId: props.projectId,
        userId: item.userId,
        taskNum: +item.taskNum
      };
    });
  }
});
</script>
<style lang="scss"></style>
